import { useState } from 'react';
import {
//   apiGetDownloadConfigurator,
  deleteRetailAutomationApi,
  retailAutomationUpdateApi,
//   deleteMultipleConfiguratorsApi,
} from '../api/retailAutomationApis';
import { MODEL_TYPES } from '../constants/constants';
import { useUserContext } from '../contexts/UserContext';
import { useModelActions } from './useModelActions';
// import { download } from '../common/DownloadFileController/downloadFile';
import { errorToast, successToast } from '../helpers/toastHelper';
import { useInfoDialogaActions } from './useInfoDialogaActions';
import { warningToast } from '../helpers/toastHelper';
import { isAdminOrOwner } from '../helpers/userHelper';
import { dispatcher } from '../helpers/projectHelper';
import { retailAutomationListSelectors } from '../redux/slicers/retailAutomationListSlicer';
import { closeInfoDialog } from '../redux/slicers/infoDialogSlicer';
import { clearCacheFromAPI } from '../helpers/jsHelper';

export const useRetailAutomationActions = ({ item }) => {
  const { currentUser } = useUserContext();
  const { openInfoDialog } = useInfoDialogaActions();
//   const [downloading, setDownloading] = useState(false);
  const [deleteConf, setDeleteConf] = useState(false);
//   const { downloadConfigurator, downloadLoading } = useDownloadConfigurator();
  const { deleteRetailAutomation, deleteLoading, deleteSucess } = useDeleteRetailAutomation();
  const { favouriteLoading, onFavouriteToggle, onShare, addToCollection } = useModelActions({
    item,
    modelType: MODEL_TYPES.RETAIL_AUTOMATION,
    selectors: retailAutomationListSelectors,
    updateApi: retailAutomationUpdateApi,
    deleteConfig: {
      title: `Do you want to delete ${item?.name}?`,
      deleteApi: deleteRetailAutomation,
    },
  });

//   const download = async (id) => {
//     setDownloading(true);
//     // TODO: implement downloading
//     await downloadConfigurator(id);
//     setDownloading(false);
//   };

  const onDelete = async (id) => {
    setDeleteConf(true);
    const { created_by_details, name } = item;
    if (!isAdminOrOwner(currentUser) && created_by_details.id !== currentUser.id) {
      setDeleteConf(false);
      warningToast('You do not have ownership to delete this item.', {
        toastId: `CAN_NOT_DELETE_${item.id}`,
      });
      return;
    }
    openInfoDialog({
      title: `Do you want to delete ${name || 'this retail automation'}?`,
      description: 'Your items can be restored from the Trash area.',
      cancelButtonText: 'No',
      buttonText: 'Yes',
      onButtonClick: async () => {
        clearCacheFromAPI();
        await deleteRetailAutomation(id);
      },
    });
  };
  return {
    onDelete,
    onFavouriteToggle,
    favouriteLoading,
    // download,
    // downloading,
    onShare,
    addToCollection,
    deleteSucess
  };
};

// export const useDownloadConfigurator = () => {
//   const [loading, setLoading] = useState(false);
//   const downloadConfigurator = async (idOrList) => {
//     if (loading) return;
//     setLoading(true);
//     await downloadProjectFile(idOrList);
//     setLoading(false);
//   };
//   return { downloadConfigurator, downloadLoading: loading };
// };

// const downloadProjectFile = async (idOrList) => {
//   const formData = new FormData();
//   if (Array.isArray(idOrList)) {
//     idOrList.forEach((id) => {
//       formData.append('id', id);
//     });
//   } else {
//     formData.append('id', idOrList);
//   }
//   const res = await apiGetDownloadConfigurator(formData);
//   if (res.status) {
//     res?.data?.zip_file?.map((item) => {
//       download({
//         fileUrl: item.zip_url,
//         fileName: `${item.name}.zip`,
//       });
//     });
//   } else {
//     errorToast(res?.message);
//   }
// };

export const useDeleteRetailAutomation = () => {
  const [loading, setLoading] = useState(false);
  const [deleteSucess, setDeleteSuccess] = useState(false);

  const deleteRetailAutomation = async (idOrList) => {
    if (loading) return;
    setLoading(true);
    setDeleteSuccess(false);
    let res = await deleteRetailAutomationFile(idOrList);
    if (res) {
      successToast('Retail automation deleted successfully');
      closeInfoDialog();
      setDeleteSuccess(true);
    }
    setLoading(false);
  };

  return { deleteRetailAutomation, deleteLoading: loading, deleteSucess: deleteSucess };
};

const deleteRetailAutomationFile = async (idOrList) => {
  const formData = new FormData();
  let res;
  if (Array.isArray(idOrList)) {
    idOrList.forEach((id) => {
      formData.append('id', id);
    });
    // res = await deleteMultipleConfiguratorsApi(formData);
  } else {
    res = await dispatcher(deleteRetailAutomationApi(idOrList));
  }
  return res;
};
